import { render } from "./navi.vue?vue&type=template&id=8a20955c&scoped=true"
import script from "./navi.vue?vue&type=script&lang=js"
export * from "./navi.vue?vue&type=script&lang=js"

import "./navi.vue?vue&type=style&index=0&id=8a20955c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a20955c"],['__file',"src/js/components/navi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a20955c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a20955c', __exports__)) {
    api.reload('8a20955c', __exports__)
  }
  
  module.hot.accept("./navi.vue?vue&type=template&id=8a20955c&scoped=true", () => {
    api.rerender('8a20955c', render)
  })

}


export default __exports__